import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

function toQuery(params = {}) {
  const qp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qp.set(key, value);
  });
  return qp.toString();
}

export async function getCajaEstado() {
  const url = `${API_BASE_URL}/api/cajero/caja/estado`;
  const res = await fetchWithAuth(url, { method: 'GET', headers: { Accept: 'application/json' } });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(body || 'Error al obtener estado de caja');
  }
  return res.json();
}

export async function abrirCaja(payload = {}) {
  const url = `${API_BASE_URL}/api/cajero/caja/abrir`;
  const res = await fetchWithAuth(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(body || 'Error al abrir caja');
  }

  return res.json();
}

export async function cerrarCaja(payload = {}) {
  const url = `${API_BASE_URL}/api/cajero/caja/cerrar`;
  const res = await fetchWithAuth(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(body || 'Error al cerrar caja');
  }

  return res.json();
}

export async function getCajaResumen({ idCaja, agrupado_por_operacion = true } = {}) {
  const query = toQuery({ idCaja, agrupado_por_operacion: agrupado_por_operacion ? 1 : 0 });
  const url = `${API_BASE_URL}/api/cajero/caja/resumen${query ? `?${query}` : ''}`;

  const res = await fetchWithAuth(url, { method: 'GET', headers: { Accept: 'application/json' } });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(body || 'Error al obtener resumen de caja');
  }

  return res.json();
}
